import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e02957e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container flex justify-between items-center h-36" }
const _hoisted_2 = { class: "text-gray-400 text-lg py-3" }
const _hoisted_3 = {
  class: "text-gray-700 text-xl py-3 flex items-center",
  href: "https://salaxy.s-iis.com/",
  target: "_blank"
}
const _hoisted_4 = { class: "text-gray-400 text-lg py-3" }
const _hoisted_5 = {
  class: "text-gray-700 text-xl py-3 flex items-center",
  href: "https://www.s-oceanmind.com/",
  target: "_blank"
}
const _hoisted_6 = { class: "text-gray-400 text-lg py-3" }
const _hoisted_7 = {
  class: "text-gray-700 text-xl py-3 flex items-center",
  href: "https://recruit.sinovatio.com",
  target: "_blank"
}
const _hoisted_8 = { class: "text-gray-400 text-lg py-3" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "w-full h-full flex justify-between" }
const _hoisted_11 = {
  key: 0,
  href: "/"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = ["src"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hidden" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hidden" }, null, -1))
const _hoisted_16 = {
  key: 0,
  class: "fixed right-10 bottom-36 flex flex-col -gap-y-2 z-50"
}
const _hoisted_17 = {
  key: 1,
  class: "fixed right-0 bottom-10 flex flex-col -gap-y-2 z-fullscreen z-50"
}
const _hoisted_18 = { class: "container grid grid-cols-12" }
const _hoisted_19 = { class: "col-span-6" }
const _hoisted_20 = { class: "h-full flex flex-col justify-center gap-4" }
const _hoisted_21 = {
  key: 0,
  class: "flex flex-col items-start gap-4"
}
const _hoisted_22 = {
  key: 0,
  class: "text-primary text-xl"
}
const _hoisted_23 = { class: "flex flex-col items-start text-sm" }
const _hoisted_24 = ["src"]
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = { class: "col-span-6" }
const _hoisted_27 = { class: "h-full flex flex-col justify-center items-end gap-4" }
const _hoisted_28 = {
  key: 0,
  class: "flex flex-col items-start gap-4"
}
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = { class: "flex flex-col items-start text-sm" }
const _hoisted_31 = ["src"]
const _hoisted_32 = ["innerHTML"]

import { reactive, ref, watch } from 'vue';
import { useMeta, debounce } from 'quasar';
import ChangeLanguage from 'components/ChangeLanguage.vue';
import ChatBot from 'components/ChatBot.vue';
// import SvBtnDropdown from 'components/SvBtnDropdown.vue';
import SvProductMenu from 'components/SvProductMenu.vue';
import tmpl from 'src/utils/tmpl';
import { useI18n } from 'vue-i18n';
import ContactPopupPage from 'components/ContactPopupPage.vue';
import AppLink from 'src/components/AppLink.vue';
import SinovatioFooter from './SinovatioFooter.vue';


import { useLayoutStore } from 'stores/modules/layout';
import { usePageStore } from 'stores/modules/page';
import { useMetaStore } from 'stores/modules/meta';
import 'animate.css';
import 'hover.css';

const productMenus = process.env.PRODUCT_MENU?.split(',') ?? [];
console.log(productMenus);
const shortcutEnabled = process.env.SHORTCUTS_ENABLED === 'true';
const theme = process.env.THEME;
const dark = theme === 'dark';

const __default__ = {
  async preFetch({ store }) {
    const metaStore = useMetaStore(store);
    await metaStore.fetchAll();

    const layoutStore = useLayoutStore(store);
    await layoutStore.fetch({ url: '^$' });

    const pageStore = usePageStore(store);
    await pageStore.fetchAll();
  },
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'MainLayout',
  setup(__props) {

const { t } = useI18n();
const state = reactive<{
  page?: any;
  menusOver: boolean;
  menuOver: boolean;
  listOver: boolean;
  visible: boolean;
  dialogVisible: boolean;
  robotDialogVisible: boolean;
}>({
  menusOver: false,
  menuOver: false,
  listOver: false,
  visible: false,
  dialogVisible: false,
  robotDialogVisible: false,
});

const collapseRef = ref<HTMLElement[]>();
const hiddenMenus = debounce(() => {
  state.visible = state.menuOver || state.listOver;

  if (!state.visible && !state.menusOver) {
    for (const target of collapseRef.value ?? []) {
      if (target) {
        for (let i = 0; i < target.children.length; i++) {
          const el = target.children[i];
          el?.classList.remove('animate__fadeInUp');
          el?.classList.add('animate__fadeOutDown');
        }
      }
    }
  }
});

watch(
  () => [state.menuOver, state.listOver, state.menusOver],
  () => {
    hiddenMenus();
  }
);

const layoutStore = useLayoutStore();
const layout = layoutStore.layout;

const metaStore = useMetaStore();
useMeta(metaStore.meta);
const settings = metaStore.settings;

const pageStore = usePageStore();
const menus = pageStore.menus;

const toggleMenus = debounce((e: Event) => {
  // (e.target as HTMLElement).onmouseleave = onMouseLeaveMenu;
  state.menusOver = true;

  for (const target of collapseRef.value ?? []) {
    if (target) {
      for (let i = 0; i < target.children.length; i++) {
        const el = target.children[i];
        el?.classList.remove('animate__fadeOutDown', 'collapse');
        el?.classList.add('animate__fadeInUp');
      }
    }
  }
});

const onMouseLeaveMenu = debounce((e: Event) => {
  state.menusOver = false;
});

const maskRef = ref<HTMLElement>();
watch(
  () => pageStore.loading,
  (newValue) => {
    const el = maskRef.value;
    if (newValue) {
      el?.classList.remove('hidden');
      el?.classList.add('flex');
    } else {
      el?.classList.add('animate__animated', 'animate__fadeOut');
      el?.addEventListener(
        'animationend',
        (e: Event) => {
          e.stopPropagation();
          el?.classList.remove('flex', 'animate__animated', 'animate__fadeOut');
          el?.classList.add('hidden');
        },
        { once: true }
      );
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_header = _resolveComponent("q-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_q_spinner_dots = _resolveComponent("q-spinner-dots")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn_group = _resolveComponent("q-btn-group")!
  const _component_q_page_container = _resolveComponent("q-page-container")!
  const _component_q_footer = _resolveComponent("q-footer")!
  const _component_q_layout = _resolveComponent("q-layout")!
  const _directive_scroll_to = _resolveDirective("scroll-to")!

  return (_openBlock(), _createBlock(_component_q_layout, {
    id: "top",
    class: _normalizeClass(`theme-${_unref(theme)}`),
    view: "hHh lpR fff"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_header, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(layout).regions?.filter((t) => /^header-top/.test(t.name)), (header) => {
            return (_openBlock(), _createBlock(_component_q_toolbar, {
              key: header.id,
              class: "h-7 min-h-min bg-black flex justify-end -gap-x-4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_btn_dropdown, {
                  label: _unref(t)('MainLayout.header.websites'),
                  flat: "",
                  dense: "",
                  round: "",
                  "content-class": "left-0! right-0! max-w-none! w-full flex justify-center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("ul", _hoisted_1, [
                      _createElementVNode("li", null, [
                        _createVNode(_component_router_link, {
                          class: "text-gray-700 text-xl py-3 flex items-center",
                          to: "/"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_icon, {
                              class: "text-green-600",
                              name: "mdi-chevron-right",
                              size: "30px"
                            }),
                            _createElementVNode("span", null, _toDisplayString(_unref(t)('MainLayout.header.company')), 1)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('MainLayout.header.information')), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", _hoisted_3, [
                          _createElementVNode("span", null, _toDisplayString(_unref(t)('MainLayout.header.salaxy')), 1),
                          _createVNode(_component_q_icon, {
                            class: "text-gray-500",
                            name: "mdi-chevron-right",
                            size: "30px"
                          })
                        ]),
                        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('MainLayout.header.salaxyProduct')), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", _hoisted_5, [
                          _createElementVNode("span", null, _toDisplayString(_unref(t)('MainLayout.header.oceanmind')), 1),
                          _createVNode(_component_q_icon, {
                            class: "text-gray-500",
                            name: "mdi-chevron-right",
                            size: "30px"
                          })
                        ]),
                        _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('MainLayout.header.oceanmindProduct')), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", _hoisted_7, [
                          _createElementVNode("span", null, _toDisplayString(_unref(t)('MainLayout.header.joinsec')), 1),
                          _createVNode(_component_q_icon, {
                            class: "text-gray-500",
                            name: "mdi-chevron-right",
                            size: "30px"
                          })
                        ]),
                        _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)('MainLayout.header.recruit')), 1)
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(ChangeLanguage),
                _createElementVNode("div", null, [
                  _createVNode(_component_q_icon, { name: "mdi-phone" }),
                  _createElementVNode("a", {
                    class: "px-1 text-sm",
                    href: `tel:${
                _unref(settings)[_unref(t)('MainLayout.header.hotline')] ?? '400-100-8102'
              }`
                  }, _toDisplayString(_unref(settings)[_unref(t)('MainLayout.header.hotline')] ?? '400-100-8102'), 9, _hoisted_9)
                ])
              ]),
              _: 1
            }))
          }), 128)),
          _createVNode(_component_q_toolbar, { class: "h-16 min-h-min flex justify-between" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(layout).regions?.filter((t) => /^header-(?:left|center|right)$/.test(t.name)), (header) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: header.id,
                    class: "px-10 flex justify-between items-center"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(header.children, (region) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: region.id
                      }, [
                        (region.name === 'logo')
                          ? (_openBlock(), _createElementBlock("a", _hoisted_11, [
                              _createElementVNode("img", {
                                class: "max-h-14",
                                src: region.image
                              }, null, 8, _hoisted_12)
                            ]))
                          : _createCommentVNode("", true),
                        (region.name === 'toggle-icon')
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: "h-full w-10 px-2 flex items-center",
                              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(toggleMenus) && _unref(toggleMenus)(...args)))
                            }, [
                              _createElementVNode("img", {
                                class: "cursor-pointer",
                                src: region.icon
                              }, null, 8, _hoisted_13)
                            ]))
                          : _createCommentVNode("", true),
                        (region.name === 'toggle-menus')
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 2,
                              class: "flex overflow-hidden",
                              onMouseleave: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(onMouseLeaveMenu) && _unref(onMouseLeaveMenu)(...args)))
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menus), (page) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                  key: page.id
                                }, [
                                  (page.children?.length)
                                    ? (_openBlock(), _createBlock(_component_q_btn, {
                                        key: 0,
                                        class: "h-16 lg:px-4 xl:px-6 text-sm text-primary hover:text-highlight",
                                        label: page.title,
                                        flat: "",
                                        "no-caps": "",
                                        onMouseenter: 
                        () => {
                          state.page = page;
                          state.menuOver = true;
                        }
                      ,
                                        onMouseover: 
                        () => {
                          state.page = page;
                          state.menuOver = true;
                        }
                      ,
                                        onMouseout: 
                        () => {
                          state.page = page;
                          state.menuOver = false;
                        }
                      ,
                                        onClick: _cache[1] || (_cache[1] = 
                        (e) => {
                          e.preventDefault();
                          e.stopPropagation();
                        }
                      )
                                      }, null, 8, ["label", "onMouseenter", "onMouseover", "onMouseout"]))
                                    : (_openBlock(), _createBlock(_component_q_btn, {
                                        key: 1,
                                        class: "h-16 lg:px-4 xl:px-6 text-sm text-primary hover:text-highlight",
                                        to: _unref(tmpl)(page.url!, page),
                                        label: page.title,
                                        flat: "",
                                        "no-caps": ""
                                      }, null, 8, ["to", "label"]))
                                ], 64))
                              }), 128))
                            ], 32))
                          : _createCommentVNode("", true),
                        (region.name === 'search')
                          ? (_openBlock(), _createBlock(_component_q_btn, {
                              key: 3,
                              class: "text-gray-800 hover:text-green-600",
                              to: "/news/search",
                              icon: "mdi-magnify",
                              flat: "",
                              round: ""
                            }))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ]))
                }), 128))
              ]),
              _createVNode(_component_q_popup_proxy, {
                class: "left-0! right-0! max-w-none! w-full flex justify-center rounded-none animate__animated animate__faster opacity-75",
                modelValue: state.visible,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((state.visible) = $event)),
                "no-parent-event": ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "w-full !max-w-full flex justify-center",
                    onMouseover: _cache[3] || (_cache[3] = () => (state.listOver = true)),
                    onMouseout: _cache[4] || (_cache[4] = () => (state.listOver = false))
                  }, [
                    (_unref(productMenus).includes(state.page.title))
                      ? (_openBlock(), _createBlock(SvProductMenu, {
                          key: 0,
                          pages: state.page.children
                        }, null, 8, ["pages"]))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: _normalizeClass(`container pt-4 flex -gap-x-24 text-primary ${
                state.page.children.every((t) => t.title.length < 8)
                  ? 'justify-center'
                  : 'justify-start'
              }`)
                        }, [
                          _hoisted_14,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.page.children, (child) => {
                            return (_openBlock(), _createBlock(AppLink, {
                              key: child.id,
                              class: "mb-4 hover:text-highlight text-sm",
                              to: _unref(tmpl)(child.url!, child)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(child.title), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          }), 128)),
                          _hoisted_15
                        ], 2))
                  ], 32)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_q_page_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_view),
          _createElementVNode("div", {
            ref_key: "maskRef",
            ref: maskRef,
            class: _normalizeClass(`mask fixed top-0 bottom-0 left-0 right-0 hidden justify-center items-center h-dvh`)
          }, [
            _createVNode(_component_q_spinner_dots, {
              class: "text-4xl",
              color: "loading-color"
            })
          ], 512),
          _createVNode(_component_q_dialog, {
            modelValue: state.dialogVisible,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((state.dialogVisible) = $event)),
            class: "overflow-hidden"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card, { class: "contact-dialog" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_separator),
                  _createVNode(_component_q_card_section, { class: "scroll" }, {
                    default: _withCtx(() => [
                      _createVNode(ContactPopupPage)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_q_dialog, {
            modelValue: state.robotDialogVisible,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((state.robotDialogVisible) = $event)),
            class: "overflow-hidden",
            "transition-show": "slide-left",
            "transition-hide": "slide-right"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card, { class: "contact-dialog" }, {
                default: _withCtx(() => [
                  _createVNode(ChatBot)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          shortcutEnabled
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createVNode(_component_q_btn_group, {
                  class: "shortcuts flex flex-col items-center bg-white",
                  rounded: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_btn, {
                      icon: "mdi-phone",
                      "fab-mini": ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_tooltip, {
                          anchor: "center left",
                          self: "center right"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, _toDisplayString(_ctx.$t('MainLayout.suspend.hotline')), 1),
                            _createElementVNode("div", null, _toDisplayString(_unref(settings)[_ctx.$t('MainLayout.suspend.hotline')] ??
                  _ctx.$t('MainLayout.header.phone')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_q_separator, { class: "w-7" }),
                    _createVNode(_component_q_btn, {
                      icon: "mdi-comment-processing-outline",
                      "fab-mini": "",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (state.dialogVisible = true))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_tooltip, {
                          anchor: "center left",
                          self: "center right"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('MainLayout.suspend.online')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_btn_group, {
                  class: "shortcuts flex flex-col bg-white",
                  rounded: ""
                }, {
                  default: _withCtx(() => [
                    _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                      icon: "mdi-arrow-up-bold",
                      "fab-mini": ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_tooltip, {
                          anchor: "center left",
                          self: "center right"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('MainLayout.suspend.top')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })), [
                      [_directive_scroll_to, '#top']
                    ])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (!shortcutEnabled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("img", {
                  src: "/img/img_robot.png",
                  alt: "Robot",
                  class: _normalizeClass(["robot cursor-pointer transition-transform transform", 
            state.robotDialogVisible ? 'translate-x-full' : 'translate-x-0'
          ]),
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (state.robotDialogVisible = true))
                }, null, 2)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (
        (_unref(layout).regions?.filter((t) => /footer/.test(t.name))?.length ?? 0) ===
        0
      )
        ? (_openBlock(), _createBlock(SinovatioFooter, {
            key: 0,
            layout: _unref(layout),
            menus: _unref(menus),
            settings: _unref(settings)
          }, null, 8, ["layout", "menus", "settings"]))
        : (_openBlock(), _createBlock(_component_q_footer, {
            key: 1,
            class: "flex justify-center py-8 z-30"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_q_separator, {
                  class: "col-span-12 mb-8",
                  dark: dark
                }),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(layout).regions?.filter((t) => t.name === 'footer-left'), (footer) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: footer.id
                      }, [
                        (footer.extraProperties.theme === '竖向')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                              (footer.summary)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(footer.summary), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_23, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(footer.children, (region) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, {
                                    key: region.id
                                  }, [
                                    (region.image)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: region.image
                                        }, null, 8, _hoisted_24))
                                      : _createCommentVNode("", true),
                                    (region.summary)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 1,
                                          class: "text-secondary",
                                          innerHTML: region.summary
                                        }, null, 8, _hoisted_25))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(layout).regions?.filter((t) => t.name === 'footer-right'), (footer) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: footer.id
                      }, [
                        (footer.extraProperties.theme === '竖向')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                              (footer.summary)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "w-full text-primary text-xl",
                                    innerHTML: footer.summary
                                  }, null, 8, _hoisted_29))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_30, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(footer.children, (region) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, {
                                    key: region.id
                                  }, [
                                    (region.image)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: region.image
                                        }, null, 8, _hoisted_31))
                                      : _createCommentVNode("", true),
                                    (region.summary)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 1,
                                          class: "text-secondary",
                                          innerHTML: region.summary
                                        }, null, 8, _hoisted_32))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _: 1
          }))
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})